import { getReportUrl } from "@via/pages/projects/runs/reports/utils/helpers.ts";
import { RunReportResource } from "common";
import React, { JSX } from "react";

export function DownloadableReport({
  report,
}: {
  report: RunReportResource;
}): JSX.Element {
  const url = getReportUrl(report?.routePath);

  const handleDownload = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className="flex h-full flex-col items-center justify-center p-4 text-center">
      <p className="mb-4 text-gray-600">File preview is not available.</p>
      <button
        onClick={handleDownload}
        className="rounded bg-indigo-600 px-4 py-2 text-white transition duration-300 ease-in-out hover:bg-indigo-500">
        Click Here to Download
      </button>
    </div>
  );
}
